import React from 'react';

function Gas() {
  return (
    <div style={{ padding: '20px' }}>
      <h2>Gas Services</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </div>
  );
}

export default Gas;